export default __webpack_public_path__ + "static/media/IMG-20230718-WA0006~2 - Daksh Singh Chauhan.9da7f11c.jpg";